<template>
  <div class="mx-6">
    <div class="flex flex-col features-card bg-white rounded-lg mx-auto">
      <!-- Card Head -->
      <div class="card-head p-8 border-gray-300 flex flex-col lg:flex-row-reverse lg:justify-between">
        <div class="mb-6 lg:mb-0">
          <img v-if="(typeof image === 'string')" class="flex" :src="image" alt="card-image">
          <component v-else :is="image"  class="flex svg-illustration mx-5"/>
        </div>
        <div class="headers">
          <div class="mb-3 text-xl md:text-2xl font-bold leading-7 text-black">{{header}}</div>
          <div class="text-base leading-6 font-bold text-green-300">{{subHeader}}</div>
        </div>
      </div>

      <!-- Card Body -->
      <div class="lg:flex p-8 space-y-6 lg:space-x-12 lg:space-y-0">
        <div class="lg:w-1/2">
          <div class="text-xl font-bold leading-7 text-gray-600 mb-5">Free Account</div>
          <div class="space-y-4">
            <div class="flex font-normal text-base text-gray-600 leading-6" v-for="(freeFeature, i) in freeFeatures" :key="`free-feature-${i}-${_uid}`">
              <div><i class="text-gray-600 sr-2 sr-2 sr-v2-checkmark-circle mr-2" /></div>
              <div>{{freeFeature}}</div>
            </div>
          </div>
        </div>
        <div class="lg:w-1/2">
          <div class="text-xl font-bold leading-7 text-black mb-5">Pro Account</div>
          <div class="space-y-4">
            <div class="flex font-normal text-base text-gray-900 leading-6" v-for="(proFeature, i) in proFeatures" :key="`pro-feature-${i}-${_uid}`">
              <div><i class="text-green-300 sr-2 sr-v2-arrow-right-circle mr-2" /></div>
              <div>{{proFeature}}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card Foot -->
      <div v-if="testimonialData" class="flex flex-col md:flex-row md:justify-between p-6 bg-gray-100 rounded-b-lg space-x-2">
        <div class="testimonial flex flex-col justify-center text-sm font-medium leading-5 text-gray-900 mb-4 md:mb-0">{{testimonialData.testimonial}}</div>
        <div class="flex space-x-2 flex-row">
          <div class="flex flex-col justify-center">
            <div class="flex">
              <PAvatar 
              type="image" 
              size="md" 
              :image="testimonialData.athleteAvatar" 
              class="avatar" 
              :style="'background-size: 48px 48px !important'"
              />
              <PAvatar kind="college" size="md" :image="testimonialData.programAvatar" class="avatar z-10 -ml-4"/>
            </div>
          </div>
          <div class="flex flex-col justify-center">
            <div class="flex space-x-1">
              <div class="flex flex-wrap text-xs font-bold leading-4 text-gray-700">
                <div class="flex-no-wrap mr-1 pb-1">{{testimonialData.athleteName}}</div>
                <div v-if="testimonialData.committed" class="mb-1"><Label text="Committed" color="blue"/></div>
              </div>
            </div>
            <div class="text-2xs font-medium leading-5 text-gray-700">{{testimonialData.program}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Label, PAvatar} from '@sportsrecruits/playbook';

export default {
  name: "Card",
  props: {
    image: {type: String | Object, required: true},
    header: {type: String, required: true},
    subHeader: {type: String, required: true},
    proFeatures: {type: Array, required: true},
    freeFeatures: {type: Array, required: true},
    testimonialData: {type: Object, required: false},
  },
  components: {
    Label,
    PAvatar
  }
}
</script>

<style>
div.avatar {
  image-rendering: auto !important;
}
.card-head {
  border-bottom: solid 1px;
}
.headers {
  max-width: 640px;
}
.features-card {
  max-width: 1024px;
  box-shadow: 0px 1px 10px 2px rgb(23, 25, 36, 0.34);
}
@media screen and (min-width: 768px) {
  .testimonial {
    max-width: 440px;
  }
}
.svg-illustration {
  width: 116px;
  height: 108px;
}
</style>